import {
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
} from '@mui/material';
import {
  Code,
  Speed,
  Palette,
  QueryBuilder,
  BugReport,
  FormatAlignLeft,
} from '@mui/icons-material';

import { useTranslation } from '../hooks/useTranslation';

export const AboutPage = () => {
  const { t } = useTranslation();

  const technologies = [
    { name: 'React 19', icon: <Code />, color: 'primary' as const },
    { name: 'TypeScript', icon: <Code />, color: 'primary' as const },
    { name: 'Vite', icon: <Speed />, color: 'secondary' as const },
    { name: 'Material-UI', icon: <Palette />, color: 'primary' as const },
    {
      name: 'TanStack Query',
      icon: <QueryBuilder />,
      color: 'secondary' as const,
    },
    { name: 'ESLint', icon: <BugReport />, color: 'default' as const },
    { name: 'Prettier', icon: <FormatAlignLeft />, color: 'default' as const },
  ];

  return (
    <Box>
      <Typography variant="h3" component="h1" gutterBottom align="center">
        {t('about.title')}
      </Typography>

      <Card sx={{ mt: 4, mb: 4 }}>
        <CardContent>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('about.subtitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('about.description')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('about.description2')}
          </Typography>
        </CardContent>
      </Card>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 4 }}>
        {t('about.technologies')}
      </Typography>

      <List>
        {technologies.map((tech, index) => (
          <ListItem key={index}>
            <ListItemIcon>{tech.icon}</ListItemIcon>
            <ListItemText primary={tech.name} />
            <Chip label={tech.name} color={tech.color} size="small" />
          </ListItem>
        ))}
      </List>

      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {t('about.architecture')}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.structure')}
                secondary={t('about.architectureFeatures.structureDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.typescript')}
                secondary={t('about.architectureFeatures.typescriptDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.theme')}
                secondary={t('about.architectureFeatures.themeDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.query')}
                secondary={t('about.architectureFeatures.queryDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.forms')}
                secondary={t('about.architectureFeatures.formsDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.i18n')}
                secondary={t('about.architectureFeatures.i18nDesc')}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t('about.architectureFeatures.linting')}
                secondary={t('about.architectureFeatures.lintingDesc')}
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};
